var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreenLock1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-ca_rd",
    "data-name": "icon-ca rd",
    transform: "translate(0 -3397)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bg",
    width: 56,
    height: 56,
    transform: "translate(0 3397)",
    fill: "#02fdb1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "fi-rr-unlock",
    transform: "translate(-27.998 3409.064)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67438",
    "data-name": "Group 67438",
    transform: "translate(42.667 -0.064)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67437",
    "data-name": "Group 67437",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80496",
    "data-name": "Path 80496",
    d: "M62.664,10.606H49.332V9.272a6.666,6.666,0,0,1,12.5-3.229,1.333,1.333,0,0,0,2.332-1.295,9.332,9.332,0,0,0-17.5,4.523v1.9a6.666,6.666,0,0,0-4,6.1v8a6.674,6.674,0,0,0,6.666,6.666H62.664A6.674,6.674,0,0,0,69.33,25.27v-8A6.674,6.674,0,0,0,62.664,10.606Zm4,14.665a4,4,0,0,1-4,4H49.332a4,4,0,0,1-4-4v-8a4,4,0,0,1,4-4H62.664a4,4,0,0,1,4,4Z",
    transform: "translate(-42.667 0.064)",
    fill: "#12784a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80497",
    "data-name": "Path 80497",
    d: "M236,298.667A1.333,1.333,0,0,0,234.667,300v2.666a1.333,1.333,0,0,0,2.666,0V300A1.333,1.333,0,0,0,236,298.667Z",
    transform: "translate(-222.668 -279.998)",
    fill: "#12784a"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenLock1);
export default __webpack_public_path__ + "static/media/green-lock-1.fff1e1588000e156914ad1e57149ca6a.svg";
export { ForwardRef as ReactComponent };